export const SUPPORTED_LANGUAGES = [
	{ value: 'en-US', label: 'English (US)' },
	{ value: 'en-GB', label: 'English (UK)' },
	{ value: 'es-ES', label: 'Español' },
	{ value: 'fr-FR', label: 'Français' },
	{ value: 'de-DE', label: 'Deutsch' },
	{ value: 'it-IT', label: 'Italiano' },
	{ value: 'pt-BR', label: 'Português (Brasil)' },
	{ value: 'ja-JP', label: '日本語' },
	{ value: 'ko-KR', label: '한국어' },
	{ value: 'zh-CN', label: '中文 (简体)' },
];
